import { render, staticRenderFns } from "./MetalBimDetail.vue?vue&type=template&id=26e081e9&scoped=true"
import script from "./MetalBimDetail.vue?vue&type=script&lang=js"
export * from "./MetalBimDetail.vue?vue&type=script&lang=js"
import style0 from "./MetalBimDetail.vue?vue&type=style&index=0&id=26e081e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e081e9",
  null
  
)

export default component.exports